/**
 * Created by jack.gill on 21/11/2017.
 */
var JumpGamePlatform = function (platformsArray) {
    PIXI.Container.call(this);
    this.jumpVelocity = -100;
    this.platformsArray = platformsArray;
    this.platformWidth = this.platformsArray[0].width;
    this.visible = false;
    this.enabled = false;
    this.used = false;
    this.graphic = CC.Utility.pixiSprite(this.platformsArray[0].texture);
    this.moveSpeed = 0;
    this.type = 0;
    this.topY = 0;
    this.bottomY = 0;
    this.grappleDistance = 0;
    this.addChild(this.graphic);
    this.allGraphics = [this.graphic];
};

JumpGamePlatform.prototype = Object.create(PIXI.Container.prototype);
JumpGamePlatform.prototype.constructor = JumpGamePlatform;

JumpGamePlatform.prototype.hide = function () {
    var i;

    this.visible = false;
    this.enabled = false;

    for (i = 0; i < this.allGraphics.length; i += 1) {
        this.allGraphics[i].alpha = 0;
    }

    this.graphic.y = 0;
};

JumpGamePlatform.prototype.checkHit = function (player) {

    var hitBool, distance;
    this.topY = this.y - (this.activeGraphic.height * this.activeGraphic.anchor.y) + 10;
    this.bottomY = this.y + (this.activeGraphic.height * this.activeGraphic.anchor.y);

    if (!this.grappleable) {
        hitBool = player.oldy < this.topY && player.y >= this.topY;

        if (hitBool) {
            hitBool = Math.abs(this.x - player.x) < this.activeGraphic.width * 0.5;
        }
        if (hitBool) {
            hitBool = (this.worldTransform.ty - (this.activeGraphic.height * this.activeGraphic.anchor.y)) < CC.WebApp.current.screenHeight
        }
    }
    else {
        hitBool = true;

        if (hitBool) {
            distance = CC.Geometry.vectorDistanceSquared(
                this.position,
                {
                    x: player.position.x - (player.graphic.width * (player.graphic.anchor.x - 0.5)),
                    y: player.position.y - (player.graphic.height * (player.graphic.anchor.y - 0.5))
                });
            hitBool = distance < this.grappleDistance;
        }

        if (hitBool) {
            hitBool = (this.worldTransform.ty - (this.activeGraphic.height * this.activeGraphic.anchor.y)) < CC.WebApp.current.screenHeight
        }
    }

    return hitBool && this.enabled;
};

JumpGamePlatform.prototype.hit = function () {
    this.used = true;
    if (this.destroyable) {
        this.enabled = false;
        TweenLite.to(this.graphic, 0.5, {alpha: 0});
        TweenLite.to(this.graphic, 0.5, {y: 100, onComplete: this.hide.bind(this)});
        //TweenLite.to(this.graphic.scale, 0.2, {x: 1.5, y: 1.5});
    }
    else if (this.grappleable) {
        this.grappleable = false;
        TweenLite.to(this.grappleGraphic, 1, {alpha: 0, ease: Power2.easeOut});
        TweenLite.to(this.grappleGraphic.scale, 1, {x: 2, y: 2, ease: Power2.easeOut});
    }
    else {
        this.graphic.scale.x = 1.1;
        this.graphic.scale.y = 0.9;
        this.graphic.y = 10;
        TweenLite.to(this.graphic, 0.5, {ease: Back.easeOut, y: 0});
        TweenLite.to(this.graphic.scale, 0.5, {x: 1, y: 1, ease: Back.easeOut});
    }
};

JumpGamePlatform.prototype.show = function (x, y, type) {

    var i = 0;

    TweenLite.killTweensOf(this.graphic);

    for (i; i < this.allGraphics.length; i += 1) {
        this.removeChild(this.allGraphics[i]);
    }

    this.allGraphics = [];
    this.previousType = this.type;
    this.type = type || 0;
    var obj = this.platformsArray[this.type];
    this.jumpVelocity = obj.jump_velocity;
    this.nextPlatformDistance = obj.next_platform_distance;
    this.destroyable = !!obj.destroyable;
    this.grappleable = !!obj.grappleable;
    this.enabled = true;
    this.used = false;

    if (obj.texture !== undefined || (obj.desktop_texture !== undefined && !CC.isMobile) || (obj.mobile_texture !== undefined && CC.isMobile)) {
        this.graphic = Widgets.createAsset(obj);
        this.allGraphics.push(this.graphic);
    }

    this.visible = true;
    this.graphic.scale.set(1, 1);
    this.platformWidth = this.graphic.width;
    this.platformHeight = this.graphic.height;
    this.halfHeight = this.graphic.height / 2;
    this.x = x;
    this.y = y;

    //Moving platform
    this.moveSpeed = obj.move_speed;
    this.moveDirection = (Math.floor(Math.random() * 2)) === 0 ? -1 : 1;

    //Shrinking platform
    this.shrinkSpeed = Number(obj.shrink_speed);
    if (this.shrinkSpeed) {

        this.graphic.scale.set(Math.random());
        this.shrinkDirection = (Math.floor(Math.random() * 2) === 0) ? 1 : -1;

        if (obj.shrink_graphic !== undefined) {

            this.shrinkGraphic = Widgets.createAsset(obj.shrink_graphic);
            if (this.shrinkDirection > 0) {
                this.shrinkGraphic.alpha = 0;
            }
            else {
                this.shrinkGraphic.alpha = 1;
                this.graphic.alpha = 0;
            }
            this.shrinkGraphic.scale.set(this.graphic.scale.x);
            this.allGraphics.push(this.shrinkGraphic);
        }
    }

    //Deadly platform
    this.deadly = !!obj.deadly;

    //Creatable platform
    this.waitingToBeCreated = false;
    if (obj.creator_graphic !== undefined) {
        this.creatorGraphic = Widgets.createAsset(obj.creator_graphic);
        this.allGraphics.push(this.creatorGraphic);
        this.creatorGraphic.scale.set(this.graphic.scale.x);
        this.waitingToBeCreated = true;
    }

    this.switchActiveGraphicAndMakeItVisible();

    if (this.waitingToBeCreated) {
        this.activeGraphic.interactive = true;
        this.activeGraphic.mousedown = this.inputOn.bind(this);
        this.activeGraphic.touchstart = this.inputOn.bind(this);
    }

    if (this.grappleable) {
        if (obj.grapple_area_graphic) {
            this.grappleGraphic = Widgets.createAsset(obj.grapple_area_graphic);
            this.grappleDistance = this.grappleGraphic.height * 0.5;
            this.grappleDistance *= this.grappleDistance;
            this.allGraphics.unshift(this.grappleGraphic);
        }
        else {
            this.grappleable = false;
        }
    }

    i = 0;
    for (i; i < this.allGraphics.length; i += 1) {
        this.addChild(this.allGraphics[i]);
    }

};

JumpGamePlatform.prototype.switchActiveGraphicAndMakeItVisible = function SwitchActiveGraphicAndMakeItVisible() {

    var i;

    for (i = 0; i < this.allGraphics.length; i += 1) {
        this.allGraphics[i].alpha = 0;
    }

    if (this.waitingToBeCreated) {
        this.activeGraphic = this.creatorGraphic;
        this.creatorGraphic.alpha = 1
    }
    else if (this.shrinkSpeed) {
        if (this.shrinkGraphic !== undefined && this.shrinkDirection < 0) {
            this.activeGraphic = this.shrinkGraphic;
            this.shrinkGraphic.alpha = 1;
        }
        else {
            this.activeGraphic = this.graphic;
            this.graphic.alpha = 1;
        }
    }
    else {
        this.activeGraphic = this.graphic;
        this.graphic.alpha = 1;
    }

};

JumpGamePlatform.prototype.inputOn = function InputOn(event) {

    if (this.waitingToBeCreated) {
        this.graphic.scale.set(this.creatorGraphic.scale.x);
        this.creatorGraphic.alpha = 0;
        this.graphic.alpha = 1;
        this.waitingToBeCreated = false;
        sound.play(Screens.json.audio.create_platform, 1);
        this.switchActiveGraphicAndMakeItVisible();
    }
    else if (this.grappleable) {
        console.log("Grapple");
    }

};